<template>
  <div class="row">
    <div class="col-md-12">
      <modal :modalContentClasses="{'no-close-on-backdrop':false}" :show.sync="ModalRute">
        <template slot="header">
          <h5 v-if="user" class="modal-title sub_title sub_title" id="exampleModalLabel">Rutero del repartidor
            {{ user.name + ' ' + user.last_name }}</h5>
        </template>
        <div class="container">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 text-center">
                <h3>Debe ordenar los restaurantes desplazando cada uno en la prioridad de entrega estimada.</h3>
                <img src="/img/IMAGES/icons8-drag-and-drop-50.png" alt="">
              </div>
              <div class="col-12 text-left">
                <draggable v-model="restaurant">
                  <b-list-group-item class="drag mt-2 d-flex justify-content-between align-items-center"
                                     v-for="(element,index) in restaurant" :key="index">
                    {{ element.name +' - '+GetAddress(element.address) }}
                    <b-badge variant="primary" pill>{{ index + 1 }}</b-badge>
                  </b-list-group-item>
                </draggable>
              </div>
              <div class="col-12 mt-3">
                <base-button id="btn_create" type="primary btn_submit" @click="save()"
                >Guardar
                </base-button>
              </div>
              <div class="col-12 mt-3">
                <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                               label="Guardando"></base-progress>
              </div>

            </div>
          </div>

        </div>
        <template slot="footer">
        </template>

      </modal>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {bus} from './bus-dealers'
import {dealers_service} from "@/services/dealers/DealersService";
import _ from 'lodash'
import swal from "sweetalert";

export default {

  components: {
    draggable,
  },
  data() {
    return {
      progress: 0,
      ModalRute: false,
      restaurant: [],
      user: []
    }
  },
  name: "rute",
  methods: {
    save() {
      this.progress = 50
      for (const arr in this.restaurant) {
        this.restaurant[arr].priority = Number(arr) + 1
      }
      const restaurantes =  _.filter(this.restaurant, (u) => {
        return u.type === '2'
      })
      const usuarios =  _.filter(this.restaurant, (u) => {
        return u.type === '1'
      })
      if (restaurantes.length > 0){
        const restaurantesupdate = []
        for (const res in restaurantes){
          restaurantesupdate.push({'restaurant_id':restaurantes[res].id,'priority':restaurantes[res].priority})
        }
        dealers_service.UpdateRestaurant(restaurantesupdate)
      }
      if (usuarios.length > 0){
        const usuariosupdate = []
        for (const res in usuarios){
          usuariosupdate.push({'user_id':usuarios[res].id,'priority':usuarios[res].priority})
        }
        dealers_service.UpdateUsers(usuariosupdate)
      }
      swal({
        icon: "success",
        text: "Prioridad De Entrega Guardada Correctamente",
        button: "Aceptar"
      })
      this.progress = 0


    },
    GetAddress(address) {
      if (address[0] === '[') {
        const dir = JSON.parse(address)
        return dir[0].address
      } else {
        return address
      }
    }
  },
  created() {
    bus.$on('OpenRute', (user, user_id) => {
      this.ModalRute = !this.ModalRute
      this.user = user
      if (user_id > 0) {
        dealers_service.GetUserAndRest(user_id)
      }
    })
    bus.$on('GetUserAndRest', (response) => {
      this.restaurant = _.orderBy(response, 'priority', 'asc')
    })
    /*bus.$on('ResponseUpdateRestaurant', (response) => {
      this.progress = 100
      if (response.status === 200) {
        swal({
          icon: "success",
          text: "Prioridad De Entrega Guardada Correctamente",
          button: "Aceptar"
        })
        this.progress = 0
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "No fue posible Guardar la Prioridad Correctamente",
          button: "Aceptar"
        })
        this.progress = 0
      }
    })*/
  }
}
</script>

<style scoped>
.drag {
  cursor: pointer;
}
</style>